<template>
	<div class="textarea-text" :class="baseClass">
		<textarea @click.stop.prevent ref="textarea" :name="name" @focus="active = true" @blur="active = false" class="form-control" :class="inputClass" v-model="internalValue" />
		<div class="textarea-placeholder" v-if="placeholder">
			<span>{{ placeholder }}</span>
		</div>
	</div>
</template>

<script>
import { debounce } from 'lodash';

export default {
	data () {
		return {
			active: false,
			internalValue: this.value,
		};
	},
	props: {
		value: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			required: false,
		},
		icon: { // Använder klasser
			type: String,
			required: false,
		},
		glyphicon: { // Använder bootstraps glyphicons
			type: String,
			required: false,
		},
		name: {
			type: String,
			required: false,
		},
		autofocus: {
			default: false,
		},
		inputClasses: {
			default: null,
			type: Object,
		},
	},
	computed: {
		debouncedEmit () {
			//@TODO: Kolla på alternativ, eftersom vi inte vill spara i localstorage varje value change.
			return debounce(this.emitInternalValue, 1);
		},
		baseClass () {
			return [
				{
					'has-icon': !! (this.icon || this.glyphicon),
					'has-placeholder': !! this.placeholder,
					'active': this.active,
				},
				this.icon ? 'icon-' + this.icon : null,
			];
		},
		inputClass () {
			const obj = {
				nonempty: !! this.internalValue,
			};
			if (this.inputClasses) {
				Object.assign(obj, this.inputClasses);
			}
			return obj;
		},
	},
	methods: {
		emitInternalValue () {
			this.$emit('input', this.internalValue);
		},
		focus () {
			this.$refs.textarea.focus();
		},
		formatPlaceholder () {
			return this.placeholder.charAt(0).toLowerCase() + this.placeholder.slice(1);
		},
		scaling () {
			var element = this.$refs.textarea;
			element.style.height = "1px";
			element.style.height = 4+element.scrollHeight+"px";
		},
	},
	mounted () {
		this.$nextTick(() => {
			if (this.autofocus !== false) {
				if (this.$refs.textarea) {
					this.$refs.textarea.focus();
				}
			}

			this.scaling();
		});
	},
	watch: {
		value (to) {
			this.internalValue = to;
		},
		active (to) {
			if (! to) {
				this.$emit('change', to);
			}
		},
		internalValue () {
			this.scaling();
			this.emitInternalValue();
		},
	},
};
</script>
